import React, { useState, useEffect } from "react";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { selectLanguage } from "store/language/actions";
import { organisationRequest } from "store/auth/actions";

import {
  makeSelectSelectedLanguage,
  makeSelectLanguages,
} from "store/language/selector";

import {
  makeSelectOrganisation
} from "store/auth/selector";

//styles
import classes from "./incident.module.scss";

//components
import { FormattedMessage } from "react-intl";
import Footer from "components/UI/footer";
import Button from "components/UI/button";
import Heading from "components/UI/heading";

//utils
import { isNil } from "lodash";
import queryString from "query-string";

import cn from "classnames";

import { Helmet } from "react-helmet";

const IncidentReporting = ({
  languages,
  history,
  selectedLanguage,
  setSelectLanguage,
  organisation,
  getOrganization
}) => {
 

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <Heading
          title={'Incident Reporting'}
          titleId={
            'incident.reporting'
          }
          description={''}
          descriptionId={
            ''
          }
        />
        <div className={classes.HeaderWrapper}>
          <h3>NOTE: If this is an emergency, dial 111</h3>

          <p>Speak clearly and ensure background noise levels are low for the best results.</p>
        </div>

        <div className={classes.FormWrapper}>

            <div class={classes.IncidentWrapper}>
                <elevenlabs-convai agent-id="bzzr2oUvLzUmIN3zdSF8"></elevenlabs-convai>
                <div class={classes.IncidentBlocker}>
                   &nbsp;
                </div>

            </div>

            

            <Helmet>
              <script src="https://elevenlabs.io/convai-widget/index.js" async type="text/javascript"></script>
            </Helmet>
        </div>
      </div>

    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  languages: makeSelectLanguages(),
  selectedLanguage: makeSelectSelectedLanguage(),
  organisation: makeSelectOrganisation(),
});

const mapDispatchToProps = (dispatch) => {
  return {
    getOrganization: (val) => dispatch(organisationRequest(val)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IncidentReporting);
